import { SPECIALTY_COVID_19_VACCINATIONS } from '../../bookings/constants';
import { TopicChoice } from '../../common/components/SearchHeader/types/TopicChoice';
import { LinkSection } from './LinkSection/LinkSection';

export const TopicInfoLinks = ({ topic }: { topic: TopicChoice }) => {
  if (topic.specialist?.toLowerCase() === SPECIALTY_COVID_19_VACCINATIONS.toLowerCase()) {
    return <LinkSection title="COVID-19 Info" links={COVID_19_LINKS} />;
  }

  return null;
};

const COVID_19_LINKS = [
  {
    title: 'The 8 things you need to know about the COVID-19 vaccine in Australia',
    url:
      'https://healthengine.com.au/info/the-8-things-you-need-to-know-about-the-covid-19-vaccine-in-australia',
  },
  {
    title: 'Covid-19 Vaccines in Australia',
    url: 'https://healthengine.com.au/info/coronavirus-vaccines-in-australia',
  },
  {
    title: 'Covid-19 Vaccines & Your Immune System: How Do They Work? ',
    url:
      'https://healthengine.com.au/info/coronavirus-vaccines-your-immune-system-how-will-it-all-work',
  },
];
